<template>
    <!-- 营销订单管理 -->
    <div class="order-refund">
        <content-view v-show="$utils.renderWhen(this,'marketingOrder')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="用户手机号">
                        <a-input placeholder="请输入" v-decorator="['phone']" ></a-input>
                    </a-form-item>
                    <a-form-item label="商品名称">
                        <a-input placeholder="请输入" v-decorator="['commodityName']"></a-input>
                    </a-form-item>
                    <a-form-item label="订单状态">
                        <a-select allowClear placeholder="请选择" v-decorator="['payState']" >
                        <a-select-option v-for="(item, index) in $utils.payState" :value="index" :key="index">{{item}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="支付金额">
                        <a-input-group compact >
                            <a-input class="range-input range-input-left" placeholder="最小支付金额" v-decorator="['amountStart']" />
                            <a-input style="width: 40px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled />
                            <a-input class="range-input range-input-right" placeholder="最大支付金额" v-decorator="['amountEnd']" />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item label="支付时间">
                        <a-range-picker
                            style="width:282px"
                            showTime
                            format="YYYY/MM/DD HH:mm"
                            v-decorator="['payTime']"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search(false)" :loading="t_loading" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <div class="wrap-container-in">
                <div class="mb16" v-if="getBtnByAuth('exportAll')">
                    <a-button type="primary" @click="search(true)" :loading="t_loading">导出excel</a-button>
                </div>
                <a-table :loading="t_loading" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.id">
                    <span slot="payState" slot-scope="payState">{{$utils.payState[payState]}}</span>
                    <span slot="orderPlatform" slot-scope="orderPlatform,row">{{['',row.shopName,'官方APP','微信小程序','第三方APP','其他'][orderPlatform]}}</span>
                    <span slot="payTime" slot-scope="a, row">{{row.payTime ? row.payTime : "-"}}</span>
                    <span slot="payAmount" slot-scope="a, row">{{row.payAmount ? row.payAmount : 0}} </span>
                    <span slot="refundTime" slot-scope="a, row">{{row.refundTime ? row.refundTime : "-"}}</span>
                    <span slot="refundAmount" slot-scope="a, row">{{row.refundAmount ? row.refundAmount : 0}} </span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('marketingOrderDetail')">
                            <span v-if="row.orderState == 2" class="text-disabled">订单详情</span>
                            <span v-else>
                                <!-- 跳转到营销订单详情 -->
                                <router-link class="text-primary" :to="{name:'marketingOrderDetail', query: {id: row.id}}">订单详情</router-link>
                            </span>
                            <a-divider type="vertical"/>
                        </span>
                        <span v-if="getBtnByAuth('orderRefund')">
                            <a v-if="row.payState === 3 || row.payState === 6" class="text-primary" @click="openVisibleRefund(row)">退款</a>
                            <span class="text-disabled" v-else>退款</span>
                        </span>
                    </span>
                </a-table>

                <a-modal title="商品禁用选择" centered :visible="visibleGiftRefund" @ok="yesGift" @cancel="visibleGiftRefund = false">
                    是否禁用所买商品以及赠品：
                    <a-radio-group v-model="ticketForbidden">
                        <a-radio :value="true">是</a-radio>
                        <a-radio :value="false">否</a-radio>
                    </a-radio-group>
                </a-modal>
                <!-- 退款 -->
                <a-modal 
                class="billInfo-refund" 
                title="订单退款" 
                v-model="visibleRefund"
                @ok="refundSave"
                @cancel="visibleRefund = false"
                :width="1000"
                :confirmLoading="confirmLoading"
                :destroyOnClose="true">
                    <a-row class="mb16">
                        <a-col :span="8">订单状态：{{$utils.payState[detailData.payState]}}</a-col>
                        <a-col :span="8">订单号：{{detailData.id}}</a-col>
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="8">购买者手机号：{{detailData.phone}}</a-col>
                        <a-col :span="8">下单时间：{{detailData.payTime}}</a-col>
                    </a-row>
                    <a-table
                    bordered
                    :dataSource="userOrderDetails"
                    :columns="columns1"
                    :pagination="false"
                    :scroll="{y:300}"
                    :rowKey="record => record.id"
                    >
                        <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                        <span slot="refundCount" slot-scope="refundCount">{{refundCount || 0}}</span>
                        <span slot="state" slot-scope="state">{{['','待付款','支付失败','已支付','已退款','已取消'][state]}}</span>
                        <span slot="price" slot-scope="price,row">{{row.payAmount / row.number}}</span>
                    </a-table>
                    <div class="mt16 border-gray">
                        <a-row class="mb16">
                            <a-col class="red" :span="12">实收金额/元：{{detailData.payAmount}} 元</a-col>
                            <a-col class="red" :span="12">已退金额/元：0 元</a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12">购买途径：购票小程序</a-col>
                            <a-col :span="12">支付方式：微信</a-col>
                        </a-row>
                    </div>
                    <div class="border-gray mt16">
                        <a-row>
                            <a-col class="red" :span="12">
                                应退金额：
                                <span>{{detailData.payAmount}}</span> 元
                            </a-col>
                        </a-row>
                        <a-divider></a-divider>
                        <a-row>
                            <a-col :span="3">实退金额: </a-col>
                            <a-col :span="12">
                                <a-input-number :min="0" :max="detailData.payAmount" :precision="2" style="width:210px" placeholder="请输入" v-model="amount" />
                            </a-col>
                        </a-row>
                        <a-row class="mt16 mb16">
                            <a-col :span="3"> 退款原因：</a-col>
                            <a-col :span="19">
                                <a-textarea cols="10" rows="3" style="resize:none;" v-model="reason"></a-textarea>
                            </a-col>
                        </a-row>
                        <div class="mt16 mb8" style="color: #000">退款审核</div>
                        <a-row>
                            <a-col :span="12">
                                审核人职位: 
                                <a-select style="width:70%" placeholder="请选择" :labelInValue="true" @change="handleSelectChange">
                                    <a-select-option :value="item.id" v-for="item in comfirmRoleList" :key="item.id" >{{item.roleName}}</a-select-option>
                                </a-select>
                            </a-col>
                            <a-col :span="12">
                                审核人:
                                <a-select style="width:70%" @change="changeAuditor" placeholder="请选择" :labelInValue="true">
                                    <a-select-option :value="item.id" v-for="item in memberList" :key="item.id" >{{item.name}}</a-select-option>
                                </a-select>
                            </a-col>
                        </a-row>
                    </div>
                </a-modal>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import moment  from 'moment';
    const columns = [
    {
        title: "订单编号",
        dataIndex: "id"
    },
    {
        title: "用户手机号",
        dataIndex: "phone"
    },
    {
        title: "商品名称",
        dataIndex: "name"
    },
    {
        title: "购买数量",
        dataIndex: "number"
    },
    {
        title: "订单状态",
        dataIndex: "payState",
        scopedSlots: { customRender: "payState" }
    },
    {
        title: "下单时间",
        dataIndex: "orderTime",
        scopedSlots: { customRender: "orderTime" }
    },
    {
        title: "支付时间",
        dataIndex: "payTime",
        scopedSlots: { customRender: "payTime" }
    },
    {
        title: "支付金额/元",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "payAmount" }
    },
    {
        title: "退款时间",
        dataIndex: "refundTime",
        scopedSlots: { customRender: "refundTime" }
    },
    {
        title: "退款金额/元",
        dataIndex: "refundAmount",
        scopedSlots: { customRender: "refundAmount" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }]
    const columns1 = [
    {
        title: "序号",
        dataIndex: "index",
        width: 80,
        scopedSlots: { customRender: "index" }
    },
    {
        title: "已退数量",
        dataIndex: "refundCount",
        width: 80,
        scopedSlots: { customRender: "refundCount" }

    },
    {
        title: "商品名称",
        dataIndex: "name",
        width: 160,
    },
    {
        title: "商品单价",
        dataIndex: "price",
        width: 80,
        scopedSlots: { customRender: "price" }
    },
    {
        title: "购买数量",
        dataIndex: "number",
        width: 80,
        scopedSlots: { customRender: "number" }
    },
    {
        title: "合计/元",
        width: 80,
        dataIndex: "payAmount"
    }];
    export default {
        name: "marketingOrder",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                shopList: [],
                // 退款表头
                columns1,
                userOrderDetails: [],
                visibleRefund: false,
                detailData: {},
                amount: undefined,
                reason: undefined,
                comfirmRoleList: [],
                memberList: [],
                total: 0,
                labelCol: {span: 8},
                wrapperCol: {span: 16},
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                confirmLoading: false,
                t_loading: false,
                visibleGiftRefund: false,
                ticketForbidden: true,
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.userInfo = this.$userInfoTool.getUser();
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            handleReset() {
                this.form.resetFields();
            },
            search(isExport) {
                this.pagination.current = 1;
                this.getList(isExport);
            },
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    this.shopList = res;
                });
            },

            // 获取订单列表
            getList(isExport) {
                if (this.t_loading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.payTimeStart = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.payTimeEnd = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined
                    this.t_loading = true
                    this.$api.changeCode
                    .activityOrderList({
                        body: Object.assign(values, 
                        {   
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: values.searchShopId,
                            isExport: Boolean(isExport)
                        })
                    })
                    .then(res => {
                        this.pagination.total = res.total;
                        this.dataSource = res.data;
                        this.t_loading = false;
                        if (Boolean(isExport)) {
                            this.exportExcel();
                        }
                    }).catch(err => {
                        this.t_loading = false;
                    });
                });
            },

            // 导出excel
            exportExcel() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const payTime = values['payTime'] ? values['payTime'] : []
                    values.payTimeStart = payTime.length > 0 ? payTime[0].format('YYYY-MM-DD HH:mm:ss') : undefined
                    values.payTimeEnd = payTime.length > 0 ? payTime[1].format('YYYY-MM-DD HH:mm:ss') : undefined

                    this.t_loading = true
                    this.$api.changeCode
                    .activityOrderExport({
                        body: Object.assign(values, 
                        {   
                            pageNum: 1,
                            pageSize: this.pagination.total,
                            shopId: values.searchShopId,
                        })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + moment().format('YYYY/MM/DD') + '.xls'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                        this.t_loading = false

                    }).catch(err => {
                        this.t_loading = false

                    })
                });
            },

            yesGift() {
                this.visibleRefund = true;
                this.visibleGiftRefund = false;
            },

            // 打开退款详情弹框
            openVisibleRefund(row) {
                this.visibleGiftRefund = true;
                this.detailData = row;
                this.userOrderDetails = [row];
                this.amount = undefined;
                this.reason = undefined;
            },

            //审核人职位
            comfirmRole() {
                if(!this.shopId) return
                this.$api.audit.sysRoleRefund({
                }).then(res => {
                    this.comfirmRoleList = res;
                });
            },

            //审核人 根据职位筛选
            comfirmMember() {
                if(!this.shopId) return
                this.$api.audit.sysUserRefund({
                    query: {
                        shopId: this.shopId,
                        roleId: this.position
                    }
                }).then(res => {
                    this.memberList = res.filter(i => i.id !== this.userInfo.id);
                });
            },

            //切换审核人职位下拉时，改变审核人下拉为当前职位下的人
            handleSelectChange(value) {
                // value.key: 职位ID，value.label: 职位name
                this.memberList = this.comfirmMemberList.filter(item => item.roleId == value.key)
                this.position = value.key
                this.name = value.label
            },
            //切换审核人
            changeAuditor(value) {
                // value.key: 审核人ID，value.label: 审核人name
                this.auditorId = value.key
                this.auditor = value.label
            },

            // 发起退款
            refundSave() {
                if(!this.amount) {
                    this.$message.error('请输入退款金额')
                    return false
                }
                if(!this.reason) {
                    this.$message.error('请输入退款原因')
                    return false
                }
                if(!this.position) {
                    this.$message.error('请选择审核人职位')
                    return false
                }
                if(!this.auditorId) {
                    this.$message.error('请选择审核人')
                    return false
                }
                this.confirmLoading = true
                this.$api.changeCode
                .activityOrderRefund({
                    body: {
                        orderId: this.detailData.id,
                        amount: this.amount,
                        reason: this.reason,
                        auditorPosition: this.position,
                        auditor: this.auditor,
                        auditorId: this.auditorId,
                        ticketForbidden: this.ticketForbidden
                    }
                })
                .then(res => {
                    this.$message.success('操作成功，可去审核列表查看审核情况')
                    this.visibleRefund = false;
                    this.getList()
                    this.confirmLoading = false
                })
                .catch(res => {
                    this.confirmLoading = false
                })
            }
        },
        created() {},
        mounted() {
            this.getShopList()
            this.getList()
            this.comfirmRole()
            this.comfirmMember()
        },
        watch: {
            '$route'(val) {
                val.name == 'marketingOrder' && this.getList();
            },
            'shopId'(val) {
                this.comfirmRole()
                this.comfirmMember()
            }
        }
    };
</script>
<style lang="scss">
    .billInfo-refund {
        .red {
            color: rgba(245, 34, 45, 1);
        }
        .border-gray{
            border:1px solid #ddd;
            padding: 16px;
        }
    }
</style>